import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const icon: SxStyle = { cursor: 'pointer' };

export const header: SxStyle = {
  px: 2,
  py: 3.5,
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderColor: (p) => p.palette.grey[200],
};

export const content: SxStyle = {
  px: 2,
};
